'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "highlight", "truncate", "numerical", "condensed"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TableCellElement } from "./TableCell.mjs";
import { textClass } from "../../styles/layout-theme.mjs";
/**
 * Cells are the most basic unit of a table. They are contained within rows and influenced by other cells in the same column.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablecell--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableCell) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-10376&t=s9ZDoQC7G8x5OYjx-1)
 */
export var TableCell = /*#__PURE__*/forwardRef(function TableCell(_ref, ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    highlight = _ref.highlight,
    truncate = _ref.truncate,
    numerical = _ref.numerical,
    condensed = _ref.condensed,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TableCellElement, Object.assign({
    ref: ref,
    $align: align,
    $highlight: highlight,
    $truncate: truncate,
    $numerical: numerical,
    $condensed: condensed
  }, props, {
    className: cx(textClass(highlight ? 'bodySmallBold' : 'bodySmall'), props.className),
    "data-encore-id": ENCORE_DATA_IDS.TableCell
  }));
});